import { render, staticRenderFns } from "./singleSvg.vue?vue&type=template&id=20ed6aca&scoped=true&"
import script from "./singleSvg.vue?vue&type=script&lang=js&"
export * from "./singleSvg.vue?vue&type=script&lang=js&"
import style0 from "./singleSvg.vue?vue&type=style&index=0&id=20ed6aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ed6aca",
  null
  
)

export default component.exports